import React from "react";

export const FOOTER_DATA_ITEM_TOOLTIPS = {
  Bookings:
    "Number of transactions that came from email recipients who booked an offering through the email",
  Revenue: "Revenue from the bookings that came through email",
};

export const CLICK_RATE_POPOVER_KEY = "click-rate-popover-seen";

export const STATS_FIELDS = {
  clickRate: "Click rate(%)",
  openedRate: "Opened rate(%)",
  openedBy: "Opened by",
  sentTo: "Sent to",
  deliveredTo: "Delivered to",
};

{
  /* TODO: change the data to the release date of the feature when releasing */
}
export const POPOVER_TEXT = (
  <>
    <strong>Please note:</strong> Click rate for links will only be tracked for
    emails published after <strong>15 July 2026.</strong>
  </>
);

export const DRIP_SOURCE = {
  SALES_AND_MARKETING: 1,
  LISTING_SPECIFIC_DRIPS: 2,
};
